import { t } from 'i18next';

export const Tageszeit = ({ uhrzeit }: { uhrzeit: string }) => {
  if (uhrzeit === '06:00:00') {
    return (
      <div className="text-xs justify-end bg-neutrals-200 rounded-full p-1 text-neutrals-800">
        {t('widgets.weather.tageszeit.MORGENS')}
      </div>
    );
  } else if (uhrzeit === '11:00:00') {
    return (
      <div className="text-xs justify-end bg-neutrals-200 rounded-full p-1 text-neutrals-800">
        {t('widgets.weather.tageszeit.MITTAGS')}
      </div>
    );
  } else if (uhrzeit === '17:00:00') {
    return (
      <div className="text-xs justify-end bg-neutrals-200 rounded-full p-1 text-neutrals-800">
        {t('widgets.weather.tageszeit.ABENDS')}
      </div>
    );
  } else if (uhrzeit === '23:00:00') {
    return (
      <div className="text-xs justify-end bg-neutrals-200 rounded-full p-1 text-neutrals-800">
        {t('widgets.weather.tageszeit.NACHTS')}
      </div>
    );
  } else {
    return null;
  }
};
